import React from "react";

const dummyProducts: any[] = [
  {
    name: "Tenda",
    image:
      "https://images.pexels.com/photos/9410230/pexels-photo-9410230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    owner: "John Doe",
    count: 200,
  },
  {
    name: "Mobil",
    image:
      "https://images.pexels.com/photos/4033592/pexels-photo-4033592.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    owner: "Janda",
    count: 100,
  },
  {
    name: "Motor",
    image:
      "https://images.pexels.com/photos/9410230/pexels-photo-9410230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    owner: "Lola",
    count: 50,
  },
];

const TableProduct = () => {
  return (
    <table className="table-auto w-full border-none divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr className="text-left bg-blue">
          <th scope="col" className="table-header">
            #
          </th>
          <th scope="col" className="table-header">
            Image
          </th>
          <th scope="col" className="table-header">
            Owner
          </th>
          <th scope="col" className="table-header">
            Product
          </th>
          <th scope="col" className="table-header">
            Visit count
          </th>
        </tr>
      </thead>
      <tbody className="border-none bg-white divide-y divide-gray-200">
        {dummyProducts.map((product, index) => {
          return (
            <tr key={index}>
              <td className="table-data">{index + 1}</td>
              <td className="table-data">
                <div className="h-8">
                  <img
                    src={product.image}
                    alt={product.name}
                    className=" object-contain w-full h-full"
                  />
                </div>
              </td>
              <td className="table-data">{product.owner}</td>
              <td className="table-data font-medium">{product.name}</td>
              <td className="table-data font-bold">{product.count}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TableProduct;
